/**
 * Format regular price (for when product is on sale).
 *
 * @since 1.0.0
 */

import { extractNumericPrice } from '../extract-numeric-price';
import { formatPrice } from '../format-price';
import type { PriceFormatOptions } from '../types';

/**
 * Format regular price (for when product is on sale).
 *
 * @since 1.0.0
 *
 * @param regularPrice - The regular price value.
 * @param price - The current sale price.
 * @param options - Optional formatting options.
 * @return Formatted regular price string or empty if not applicable.
 */
export const formatRegularPrice = (
  regularPrice: string | number,
  price: string | number,
  options?: PriceFormatOptions
): string => {
  if (!regularPrice) {
    return '';
  }

  // If regular price and sale price are the same, don't show regular price
  if (regularPrice === price) {
    return '';
  }

  const numericRegularPrice = extractNumericPrice(regularPrice);
  const numericPrice = extractNumericPrice(price);

  // If couldn't extract valid prices or they're the same, don't show regular price
  if (!numericRegularPrice || !numericPrice || numericRegularPrice === numericPrice) {
    return '';
  }

  // Format the regular price using the same currency settings
  return formatPrice(numericRegularPrice, options);
};
